import * as React from "react";
import * as QRCode from "qrcode";

import { normalizeColor, get } from "grommet/utils";
import { useDarkMode } from "./DarkModeSwitch";
import Theme from "../utils/Theme";

const QRCodeView = ({ text, size }) => {
    const ref = React.useRef(null);
    const [isDarkMode] = useDarkMode();

    React.useEffect(() => {
        QRCode.toCanvas(ref.current, text, { errorCorrectionLevel: "H", width: size, height: size }, () => {});
    }, [ref, text, isDarkMode]);

    return <canvas ref={ref} height={size} width={size}></canvas>;
};

export default QRCodeView;
